import Vue from 'vue'
import PageTitle from '@/components/dashboard/page-title/index'
import PageBody from '@/components/dashboard/page-body/index'
import ListHeader from '@/components/dashboard/list-header/index'
import AppUpload from '@/components/dashboard/app-upload/index'
Vue.use(PageTitle)
Vue.use(PageBody)
Vue.use(ListHeader)
Vue.use(AppUpload)
